const ActionType = {
  SIGNUP_LOADING: "SignupAction.SIGNUP_LOADING",
  SIGNUP_ERROR: "SignupAction.SIGNUP_ERROR",
  SIGNUP_SUCCESS: "SignupAction.SIGNUP_SUCCESS",
};

export default ActionType;